import React from 'react';
import { Form } from 'react-bootstrap';
import useSoftwareProductCart from 'software_products/hooks/useSoftwareProductCart';

const ViewMateBusinessCart = () => {
  const {
    product,
    selectedVariant,
    numberOfUsers,
    availableNumberOfUsers,
    isAddingToCart,
    licenseType,
    onAddToCart,
    onQuantityChange,
  } = useSoftwareProductCart();

  const displayPrice = Number(selectedVariant.price).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  });

  return (
    <div className="container-fluid add-to-cart viewmate-business-cart">
      <div className="row cart-product-selection">
        <div className="col-12">
          <span>Your selection is:</span>
          <span className="product-name">
            ViewMate for Business
            <br />
            Advanced CAM Viewer
          </span>
          {!product.can_supply && (
            <span className="text-danger my-2 font-weight-bold">
              Out of Stock
            </span>
          )}
        </div>
      </div>

      <div className="row">
        <div className="col-12 mb-3">
          <div>
            License Type
            <br />
            <strong>{licenseType}</strong>
          </div>
        </div>
        <div className="col-12">
          <hr className="mt-0 mb-3" />
        </div>
        <div className="col-12">
          <Form.Group>
            <Form.Label htmlFor="num_of_users">Number of Users</Form.Label>
            <Form.Control
              as="select"
              className="w-50"
              id="num_of_users"
              value={numberOfUsers}
              onChange={onQuantityChange}
            >
              {availableNumberOfUsers.map(({ value }) => (
                <option key={value} value={value}>{value}</option>
              ))}
            </Form.Control>
          </Form.Group>
        </div>
      </div>

      <div className="row cart-total-price mb-2">
        <div className="col-12 mb-3">
          <div className="container-fluid">
            <div className="row">
              <div className="col-4 label-total-price-container">
                <span>Total</span>
              </div>
              <div className="col-8 display-total-price-container">
                <span id="display_total_price" className="total-price">
                  {displayPrice}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 text-center">
          <button
            type="button"
            className="btn btn-primary w-100 font-weight-normal py-2 px-4 cart-add-button"
            id="add-to-cart-button"
            onClick={onAddToCart}
            disabled={isAddingToCart || !product.can_supply}
          >
            {isAddingToCart ? 'Adding to Cart...' : 'Add to Cart'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewMateBusinessCart;
